module.exports = __webpack_public_path__ + "img/tianliang-logo.10a23984.png";